import TBAutomationActionTypes from './tb-automation.types';

const INITIAL_STATE = {
  status: 'idle',
  message: '',
  color: 'rgba(20, 255, 53, 1)',
  lastrun: null,
  error: null,
};

const tbautomationreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TBAutomationActionTypes.SET_TB_MESSAGE:
      return {
        ...state,

        message: action.payload,
      };

    case TBAutomationActionTypes.SET_STATUS:
      return { ...state, status: action.payload };

    case TBAutomationActionTypes.SET_COLOR:
      return { ...state, color: action.payload };

    case TBAutomationActionTypes.RESET_STATE:
      return INITIAL_STATE;

    case TBAutomationActionTypes.GET_LAST_RUN_SUCCESS:
      return { ...state, lastrun: action.payload, error: null };

    case TBAutomationActionTypes.GET_LAST_RUN_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export default tbautomationreducer;
